import { Component, OnInit, ViewChild } from '@angular/core';
import { ClientSectionComponent } from '../client-section/client-section.component';
import { ClientAddressSectionComponent } from '../client-address-section/client-address-section.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MasterService } from 'src/app/services/master.service';
import { ServiceType } from 'src/app/models/localization/service-type.model';
import { Basic } from 'src/app/core/models/basic.model';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { AccountService } from 'src/app/services/account.service';
import { ServiceRequestInsert } from 'src/app/models/service-request/service-request-insert.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ServiceRequestService } from 'src/app/services/service-request.service';
import { ServiceRequestClient } from 'src/app/models/service-request/service-request-client.model';
import { ServiceRequestAddress } from 'src/app/models/service-request/service-request-address.model';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { CommercialPurposeClauseComponent } from '../commercial-purpose-clause/commercial-purpose-clause.component';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { HtmlPolicy } from 'src/app/models/master/html-policy.model';

@Component({
  selector: 'app-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.scss']
})
export class ServiceRequestComponent implements OnInit {
  typeList: ServiceType[] = [];
  visitScheduleList: Basic<string>[] = [];
  formGroup: FormGroup;
  /**Subscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  /**Es cliente? */
  isClient: boolean = false;
  commercialPurposesPolicy = new HtmlPolicy();
  @ViewChild('clientSectionComponent', { read: ClientSectionComponent, static: false })
  public clientSectionComponent: ClientSectionComponent;
  @ViewChild('clientAddressSectionComponent', { read: ClientAddressSectionComponent, static: false })
  public clientAddressSectionComponent: ClientAddressSectionComponent;
  constructor(private formBuilder: FormBuilder,
    private masterService: MasterService,
    private commonService: CommonService,
    private accountService: AccountService,
    private authService: AuthService,
    private serviceRequestService: ServiceRequestService,
    private matDialog: MatDialog,
    private router: Router,
    private environmentService: EnvironmentService) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.getBasicData(account.clientCode);
    })
  }

  ngOnInit() {
    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) this.isClient = true;
    this.createForm();
    this.listServiceTypes();
    this.listVisitSchedules();
    this.loadCommercialPurposesPolicy();
  }
  ngAfterViewInit() {
    this.createNestedForms();
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      serviceType: ['', [Validators.required]],
      visitSchedule: ['', [Validators.required]],
      reference: [''],
      clauseAccepted: [false]
    })
  }
  createNestedForms() {
    this.formGroup.addControl('client', this.clientSectionComponent.formGroup);
    this.formGroup.addControl('newClientAddress', this.clientAddressSectionComponent.formGroup);
  }
  getBasicData(clientCode: string) {
    this.accountService.getBasicData(clientCode).subscribe(response => {
      this.formGroup.addControl('client', this.clientSectionComponent.formGroup);
      this.formGroup.addControl('newClientAddress', this.clientAddressSectionComponent.formGroup);
      this.clientSectionComponent.fillForm(response.data);
      this.clientAddressSectionComponent.fillForm(response.data);
    });
  }
  listServiceTypes() {
    this.masterService.listServiceTypes().subscribe(response => {
      this.typeList = response.data.filter(x => x.gisFlag == false && x.code != "ZT01" && x.code != "ZT02");
    })
  }
  listVisitSchedules() {
    this.masterService.listVisitSchedules().subscribe(response => {
      this.visitScheduleList = response.data;
    })
  }
  buildServiceRequestObject() {
    let complaint = new ServiceRequestInsert();
    complaint.applicant = new ServiceRequestClient();
    complaint.applicant.code = this.formGroup.get('client').get('code').value;
    complaint.applicant.name = this.formGroup.get('client').get('name').value;
    complaint.applicant.lastName = this.formGroup.get('client').get('lastName').value;
    complaint.applicant.documentTypeCode = this.formGroup.get('client').get('documentType').value;
    complaint.applicant.documentTypeName = this.clientSectionComponent.documentTypeList.find(x => x.sapCode == complaint.applicant.documentTypeCode).description;
    complaint.applicant.documentNumber = this.formGroup.get('client').get('documentNumber').value;
    complaint.applicant.homePhone = this.formGroup.get('client').get('homePhone').value;
    complaint.applicant.cellPhone = this.formGroup.get('client').get('cellPhone').value;
    complaint.applicant.emailAddress = this.formGroup.get('client').get('email').value ? this.formGroup.get('client').get('email').value : this.authService.getUser().emailAddress
    complaint.applicant.type = this.formGroup.get('client').get('type').value;
    complaint.applicant.interlocutorId = this.formGroup.get('client').get('interlocutorId').value;
    complaint.address = new ServiceRequestAddress();
    complaint.address.streetTypeCode = this.formGroup.get('newClientAddress').get('streetType').value;
    complaint.address.streetTypeName = this.clientAddressSectionComponent.streetTypeList.find(x => x.code == complaint.address.streetTypeCode).description;
    complaint.address.streetDescription = this.formGroup.get('newClientAddress').get('streetDescription').value;
    complaint.address.streetNumber = this.formGroup.get('newClientAddress').get('streetNumber').value;
    complaint.address.buildingType = this.formGroup.get('newClientAddress').get('buildingType').value;
    complaint.address.buildingDescription = this.formGroup.get('newClientAddress').get('buildingDescription').value;
    complaint.address.interiorType = this.formGroup.get('newClientAddress').get('interiorType').value;
    complaint.address.interiorDescription = this.formGroup.get('newClientAddress').get('interiorDescription').value;
    complaint.address.physicalGroupingType = this.formGroup.get('newClientAddress').get('physicalGroupingType').value;
    complaint.address.physicalGroupingDescription = this.formGroup.get('newClientAddress').get('physicalGroupingDescription').value;
    complaint.address.virtualGroupingType = this.formGroup.get('newClientAddress').get('virtualGroupingType').value;
    complaint.address.virtualGroupingDescription = this.formGroup.get('newClientAddress').get('virtualGroupingDescription').value;
    complaint.address.block = this.formGroup.get('newClientAddress').get('block').value;
    complaint.address.lot = this.formGroup.get('newClientAddress').get('lot').value;
    complaint.address.districtCode = this.formGroup.get('newClientAddress').get('districtCode').value;
    complaint.address.districtName = this.clientAddressSectionComponent.districtList.find(x => x.code == complaint.address.districtCode).description;
    complaint.address.provinceCode = this.formGroup.get('newClientAddress').get('provinceCode').value;
    complaint.address.departmentCode = this.formGroup.get('newClientAddress').get('departmentCode').value;

    complaint.visitScheduleCode = this.formGroup.get('visitSchedule').value;
    complaint.visitScheduleName = this.visitScheduleList.find(x => x.code == complaint.visitScheduleCode).description;
    complaint.reference = this.formGroup.get('reference').value;
    complaint.typeCode = this.formGroup.get('serviceType').value;
    complaint.typeName = this.typeList.find(x => x.code == complaint.typeCode).description;
    complaint.clauseAccepted = this.formGroup.get('clauseAccepted').value;
    return complaint;
  }

  async add() {

    if (this.formGroup.valid) {
      Swal.fire({
        title: 'Aviso',
        text: '¿Está seguro de registrar su solicitud de suministro con los datos ingresados?',
        showCancelButton: true,
        confirmButtonColor: '#3085D6',
        confirmButtonText: 'Sí',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          let serviceRequest = this.buildServiceRequestObject();
          this.serviceRequestService.add(serviceRequest).subscribe(response => {
            if (response.valid) {
              Swal.fire({
                title: 'Confirmación',
                html: 'Se registró su Solicitud de Suministro correctamente. </br> Numero de Solicitud: '
                  + response.data + '. </br>'
                  + 'Se envio una constancia a su correo: ' + serviceRequest.applicant.emailAddress

              }).finally(() => {
                if (this.isClient) this.router.navigate(['/ofivirtual']);
                else window.top.location.href = this.environmentService.naturalGasConnectionUrl;
              })
            }
          })
        }
      })
    } else if (this.formGroup.get('clauseAccepted').valid) {
      this.formGroup.markAllAsTouched();
      let errorHtml = await this.commonService.buildErrorHtml(this.formGroup);
      Swal.fire({
        icon: 'warning',
        html: errorHtml,
        confirmButtonText: 'Aceptar'
      })
    } else {
      this.formGroup.markAllAsTouched();
      Swal.fire('Validación', 'Debe aceptar las claúsulas de contratación.', 'warning');
    }
  }
  openCommercialPurposeClause() {
    const modal = this.matDialog.open(CommercialPurposeClauseComponent, { data: this.commercialPurposesPolicy });
    modal.afterClosed().subscribe(response => {
      if (response) this.formGroup.get('clauseAccepted').patchValue(true);
      else this.formGroup.get('clauseAccepted').patchValue(false);
    })
  }

  cancel() {
    if (this.isClient) this.router.navigate(['/ofivirtual/solicitar-servicio']);
    else this.router.navigate(['/stdln/solicitar-servicio']);
  }

  async loadCommercialPurposesPolicy() {
    this.commercialPurposesPolicy = await this.getHtmlPolicy("FINES_COMERCIALES");
  }
  async getHtmlPolicy(key: string) {
    let request = await this.masterService.getHtmlPolicy(key).toPromise();
    if (request.valid) return request.data;
  }
}
